module.exports = __webpack_public_path__ + "static/zoe-web-samsung@2x-edited-en-ad19ca524444b461889791645e3f57d9.jpg";